var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _vm.isShow ? _c('SidebarSection', {
    ref: "sidebarRef",
    attrs: {
      "width": "60%",
      "title": "ar_client_detail_group_user",
      "isShow": _vm.isShow
    },
    on: {
      "close": function ($event) {
        return _vm.$emit('update:isShow', false);
      },
      "delete": function () {
        var _vm$data;
        _vm.sidebarRef.$parent.$parent.$parent.$refs.tableRef.$refs.deleteDialog[0].open({
          data: {
            TaUserGroup: {
              Id: (_vm$data = _vm.data) === null || _vm$data === void 0 ? void 0 : _vm$data.Id
            }
          }
        });
      },
      "update:isShow": function ($event) {
        _vm.isShow = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShow = $event;
      }
    }
  }, [_vm.isShowModal ? _c('ModalGroupUser', {
    attrs: {
      "data": _vm.data,
      "is-show": _vm.isShowModal
    },
    on: {
      "refetch": function () {
        var _vm$data2;
        _vm.$emit('refetch', (_vm$data2 = _vm.data) === null || _vm$data2 === void 0 ? void 0 : _vm$data2.Id);
      },
      "update:isShow": function ($event) {
        _vm.isShowModal = $event;
      },
      "update:is-show": function ($event) {
        _vm.isShowModal = $event;
      }
    }
  }) : _vm._e(), _c('div', {
    staticClass: "mt-1"
  }, [_c('b-row', {
    staticClass: "m-0 mb-1"
  }, [_c('b-col', {
    attrs: {
      "md": "6"
    }
  }, [_c('h6', {
    staticClass: "content-title"
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_voucher_general_information")) + " ")])]), _c('b-col', {
    staticClass: "d-flex justify-content-end",
    attrs: {
      "md": "6"
    }
  }, [_c('ez-icon', {
    staticClass: "cursor-pointer mx-50",
    class: {
      'd-none': !_vm.isValidPermission(_vm.AP_UTUG01)
    },
    attrs: {
      "icon": "ezAr-icon-edit",
      "size": "24",
      "color": "#114A9F"
    },
    on: {
      "click": function ($event) {
        _vm.isShowModal = true;
      }
    }
  })], 1)], 1), _c('GeneralInfo', {
    attrs: {
      "leftWidth": "90px",
      "rightWidth": "130px",
      "list": _vm.listGeneral
    }
  })], 1), _c('div', {
    staticClass: "divider"
  }), _c('div', {
    staticClass: "mx-2 my-2",
    staticStyle: {
      "height": "68%"
    }
  }, [_c('b-tabs', [_vm.isValidPermission(_vm.AP_UTUG02) ? _c('b-tab', {
    attrs: {
      "title": "Phân quyền chức năng"
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }), _c('SwapData', {
    ref: "exchangeFunctionRef",
    attrs: {
      "data": _vm.exChangeFunctions,
      "childrens-expr": "Permission",
      "displayExpr": "NameVi"
    }
  })], 1) : _vm._e(), _vm.isValidPermission(_vm.AP_UTUG03) ? _c('b-tab', {
    attrs: {
      "title": "Phân quyền dữ liệu"
    }
  }, [_c('div', {
    staticClass: "mt-2"
  }), _c('SwapData', {
    ref: "exchangeDataRef",
    attrs: {
      "data": _vm.exChangeDatas,
      "displayExpr": "CodeName",
      "search-expr": ['CodeName']
    }
  })], 1) : _vm._e()], 1), _vm.data.InActive === 1 ? _c('LoadingModalButton', {
    ref: "buttonRef",
    staticStyle: {
      "margin-left": "auto",
      "display": "block",
      "margin-right": "6px"
    },
    attrs: {
      "variant": "primary",
      "className": "px-4 mt-2 mb-3 "
    },
    on: {
      "click": _vm.handleUpdateAuthorize
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("ar_common_save")) + " ")]) : _vm._e()], 1)], 1) : _vm._e();
}
var staticRenderFns = []

export { render, staticRenderFns }